
export const getPreviewIdA1 = () => {
    const dataA1 = getNumberRenderA(10);
    const dataB1 = getNumberRenderA(10);
    const dataC1 = Date.now();
    const dataC2 = `${dataC1}`.slice(0, 13);
    return `${dataA1}${dataC2}${dataB1}`;
};

export const getNumberRenderA = (num = 16) => {
    const id1 = `${Math.random()}`.slice(2);
    const id2 = `${Math.random()}`.slice(2);
    const id3 = `${Math.random()}`.slice(2);
    const id4 = `${Math.random()}`.slice(2);
    const id5 = `${Math.random()}`.slice(2);
    return `${id1}${id2}${id3}${id4}${id5}782491245345`.slice(0, num);
}
